import agent from "./data-agent";
import authHeader from "./auth-header";
import { notification } from 'antd';

const baseUrl = "/api/";

export async function getTruckingCompanies() {
    try {
        const url = `${baseUrl}kiosqueGetTruckingCompanies`;
        const response = await agent.get(url, { headers: authHeader() });

        return response.data || []; // Renvoie un tableau vide par d�faut

    } catch (error) {
        console.error("Erreur dans getTruckingCompanies:", error);
        return []; // Renvoie un tableau vide en cas d'erreur r�seau par eg
    }
};

export async function getUserTerminal(userCode) {
    if (!userCode) {
        return null; 
    }

    try {
        const url = `${baseUrl}kiosqueGetUserTerminal`;

        const { data: terminal = null } = await agent.get(url, {
            headers: authHeader(),
            params: { userCode }
        });

        return terminal;

    } catch (error) {
        console.error("Erreur lors de la r�cup�ration du terminal :", error);
        return null; 
    }
};

export async function getBookedEquipment(bookNumber) {
    try {
        const url = `${baseUrl}kiosqueGetBookingEquipmentBalance`;

        const response = await agent.get(url, {
            headers: authHeader(),
            params: { bookNumber }
        });

        return response.data;

    } catch (error) {
        console.error("Erreur getBookedEquipment:", error);
        return [];
    }
};

export function isRF(line) {
    return line.type === "RF";
}

export function getLinesWithPositiveRemainder(items) {
    const lines = items.filter(item => {
        return item.remainder > 0;
    });

    return lines;
}

/* ------ NOTIFICATION ------*/
export const openNotificationWithIcon = (type, description) => {
    notification[type]({
        message: 'Hunt',
        description: `${description}`,
        duration: 4
    });
};
/*----- END NOTIFICATION ---- */

export default {
    get: agent.get, //axios.get
    post: agent.post, //axios.post,
    put: agent.put, //axios.put
    patch: agent.patch, //axios.patch
    delete: agent.delete, //axios.delete
};